import { InputField } from '@segment/actions-core'
import { VEHICLE_FIELDS, TRAVEL_FIELDS } from '../constants'

export const track_fields: Record<string, InputField> = {
    event_spec_type: {
        label: 'Additional Fields',
        type: 'string',
        description: 'Include fields for travel or vehicle events.',
        choices: [
        { value: TRAVEL_FIELDS, label: 'Travel Fields' },
        { value: VEHICLE_FIELDS, label: 'Vehicle Fields' }
        ]
    },
    event: {
        label: 'Event Name',
        type: 'string',
        required: true,
        description:
        'Conversion event name. Please refer to the "Supported Web Events" section on in TikTok’s [Pixel SDK documentation](https://business-api.tiktok.com/portal/docs?id=1739585696931842) for accepted event names.'
    },
    event_id: {
        label: 'Event ID',
        type: 'string',
        description: 'Any hashed ID that can identify a unique user/session.',
        default: {
        '@path': '$.messageId'
        }
    },
    order_id: {
        label: 'Order ID',
        type: 'string',
        description: 'Order ID of the transaction.',
        default: {
        '@path': '$.properties.order_id'
        }
    },
    shop_id: {
        label: 'Shop ID',
        type: 'string',
        description: 'Shop ID of the transaction.',
        default: {
        '@path': '$.properties.shop_id'
        }
    },
    contents: {
        label: 'Contents',
        type: 'object',
        multiple: true,
        description: 'Related item details for the event.',
        properties: {
        price: {
            label: 'Price',
            description: 'Price of the item.',
            type: 'number'
        },
        quantity: {
            label: 'Quantity',
            description: 'Number of items.',
            type: 'number'
        },
        content_category: {
            label: 'Content Category',
            description: 'Category of the product item.',
            type: 'string'
        },
        content_id: {
            label: 'Content ID',
            description: 'ID of the product item.',
            type: 'string'
        },
        content_name: {
            label: 'Content Name',
            description: 'Name of the product item.',
            type: 'string'
        },
        brand: {
            label: 'Brand',
            description: 'Brand name of the product item.',
            type: 'string'
        }
        }
    },
    content_ids: {
        label: 'Content IDs',
        description:
        "Product IDs associated with the event, such as SKUs. Do not populate this field if the 'Contents' field is populated. This field accepts a single string value or an array of string values.",
        type: 'string',
        multiple: true,
        default: {
        '@path': '$.properties.content_ids'
        }
    },
    num_items: {
        label: 'Number of Items',
        type: 'number',
        description: 'Number of items when checkout was initiated. Used with the InitiateCheckout event.',
        default: {
        '@path': '$.properties.num_items'
        }
    },
    content_type: {
        label: 'Content Type',
        description:
        'Type of the product item. When the `content_id` in the `Contents` field is specified as a `sku_id`, set this field to `product`. When the `content_id` in the `Contents` field is specified as an `item_group_id`, set this field to `product_group`.',
        type: 'string',
        choices: [
        { label: 'product', value: 'product' },
        { label: 'product_group', value: 'product_group' }
        ],
        default: 'product'
    },
    currency: {
        label: 'Currency',
        type: 'string',
        description: 'Currency for the value specified as ISO 4217 code.',
        default: {
        '@path': '$.properties.currency'
        }
    },
    value: {
        label: 'Value',
        type: 'number',
        description: 'Value of the order or items sold.',
        default: {
        '@if': {
            exists: { '@path': '$.properties.value' },
            then: { '@path': '$.properties.value' },
            else: { '@path': '$.properties.revenue' }
        }
        }
    },
    description: {
        label: 'Description',
        type: 'string',
        description: 'A string description of the web event.'
    },
    query: {
        label: 'Query',
        type: 'string',
        description: 'The text string that was searched for.',
        default: {
        '@path': '$.properties.query'
        }
    },
    search_string: {
        label: 'Search String',
        type: 'string',
        description: 'The text string entered by the user for the search. Optionally used with the Search event.',
        default: {
        '@path': '$.properties.search_string'
        },
        depends_on: {
        conditions: [
            {
            fieldKey: 'event',
            operator: 'is',
            value: 'Search'
            }
        ]
        }
    }
}